import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { sanitizePayload } from '../../shared/utils/sanitize-payload';
import type { MarkerTemplateListDTO } from './model/marker-template-list.dto';

@Injectable()
export class MarkerTemplateService {
  private readonly apiUrl = environment.apiUrl;
  private readonly http = inject(HttpClient);

  getAll(): Observable<MarkerTemplateListDTO> {
    return this.http.get<MarkerTemplateListDTO>(`${this.apiUrl}/markers/templates/admin`);
  }

  update(data: MarkerTemplateListDTO): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/markers/templates`, sanitizePayload(data));
  }
}
